import { render } from "./TemplateForm.vue?vue&type=template&id=10b5618c&scoped=true&ts=true"
import script from "./TemplateForm.vue?vue&type=script&lang=ts"
export * from "./TemplateForm.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b5618c"]])

export default __exports__